import { useEffect, useState } from "react";
import AdHocFeedbackDialog from "@/components/AdHocFeedbackDialog";

/**
 * Iter 253z-2 · Global launcher for Give-Feedback dialog.
 *
 * Mounted once in AppShell. Any part of the app can pop the dialog by
 * dispatching a `CustomEvent('open-feedback-dialog', { detail: { user_id, name } })`
 * on `window`. This decouples callers (Cmd+K palette, user rows, hover cards)
 * from the dialog itself.
 */
export default function GlobalFeedbackLauncher() {
  const [target, setTarget] = useState(null);
  useEffect(() => {
    const handler = (ev) => {
      const d = ev?.detail || {};
      if (!d.user_id) return;
      setTarget({ user_id: d.user_id, name: d.name || "" });
    };
    window.addEventListener("open-feedback-dialog", handler);
    return () => window.removeEventListener("open-feedback-dialog", handler);
  }, []);
  if (!target) return null;
  return (
    <AdHocFeedbackDialog
      toUserId={target.user_id}
      toUserName={target.name}
      onClose={() => setTarget(null)}
      onSaved={() => setTarget(null)}
    />
  );
}

/** Convenience helper to fire the event from any component. */
export function openFeedbackDialog(user_id, name) {
  window.dispatchEvent(new CustomEvent("open-feedback-dialog", {
    detail: { user_id, name },
  }));
}
